(() => {
  const KEY = 'selectlinesWishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(
      new CustomEvent('selectlines:wishlist-updated', {
        detail: { count: items.length }
      })
    );
  }

  function updateButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll('.sl-wishlist-button').forEach((button) => {
      const active = wishlist.includes(button.dataset.productHandle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active);
      button.setAttribute(
        'aria-label',
        active ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.sl-wishlist-button');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle = button.dataset.productHandle;
    const wishlist = getWishlist();
    const index = wishlist.indexOf(handle);

    if (index >= 0) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
    updateButtons();
  });

  document.addEventListener('DOMContentLoaded', updateButtons);
  document.addEventListener('shopify:section:load', updateButtons);
})();